function OneEighty() {
  return (
    <div className="dice-face face--oneeighty">
      <span>180</span>
    </div>
  );
}

export default OneEighty;
